import '@babel/polyfill';
import 'static/font-awesome-extended';
import 'static/custom-icon.less';
import 'static/fonts/fonts.css';
import 'static/common.less';
import 'typed/utils/extensions';
import 'api/entityChange';
import { APIPropTypes, PropTypes, React, actions, connect } from './imports';
import { render } from 'react-dom';
import { Router, match } from 'react-router';
import store, { history } from 'store';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { RequestStatus } from 'typed/api';
import routes, { history as browserHistory, publicRoutes } from './routes';
import { applyPolyfill } from './polyfill';
import Typed from 'components/common/Typed/Typed';
import './App.less';

if (!DEBUG) {
    Sentry.init({
        release: window.forstraction?.release || '$release-identifier-filled-in-deployment$',
        environment: DEBUG ? 'debug' : 'production',
        dsn: 'https://401b56d13b5e47a186fe99116c03f720@sentry.io/135172',
        integrations: [
            new Integrations.BrowserTracing({
                tracingOrigins: [DEBUG ? 'localhost' : 'service.4straction.com', /^\//],
                routingInstrumentation: Sentry.reactRouterV3Instrumentation(browserHistory, routes, match),
                idleTimeout: 30000
            })
        ],
        sampleRate: 1.0,
        tracesSampleRate: 0.1,
        ignoreErrors: ['Sentry is not defined']
    });

    if (window.forstraction) {
        Sentry.setUser({
            id: window.forstraction.id,
            email: window.forstraction.email,
            company: window.forstraction.company
        });
    }
}

class App extends React.PureComponent {
    static get propTypes() {
        return {
            initialLoadStatus: PropTypes.oneOf(Object.values(RequestStatus)).isRequired,
            session: APIPropTypes.SessionInformation.isRequired,
            messages: APIPropTypes.networkObjectOf(PropTypes.object).isRequired
        };
    }

    state = { subscribed: false };

    componentWillMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentDidMount() {
        // kinda dirty hack
        // connect from react-redux subscribes to store changes in componentDidMount
        // this method executes from bottom to top - first for all children then for parent and so on
        // store changes are handled in order of subscription and synchronously - if parent and child depend on the same store parts
        // first the child will be updated and then the parent
        // but this component provides all stuff to descendants via context which is not handled by connect
        // so to keep context and descendants' props synchronized we have to force App to subsribe the first across the whole application
        // one way to do this is to render it without children first time and then (after componentDidMount) immediately rerender with children
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ subscribed: true });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.initialLoadStatus === RequestStatus.UNSYNCED) {
            nextProps.dispatch(actions.loadAppInitialData());
        }

        if (nextProps.initialLoadStatus === RequestStatus.SUCCEEDED && nextProps.session.Custom.status === RequestStatus.UNSYNCED) {
            nextProps.dispatch(actions.loadSession());
        }
    }

    render() {
        const { session, messages } = this.props;

        if (!this.state.subscribed || this.props.initialLoadStatus !== RequestStatus.SUCCEEDED || session.Custom.status !== RequestStatus.SUCCEEDED) {
            return (
                <div className="app">
                    <div className="loading-screen">
                        <div className="centered">
                            <Typed options={{
                                strings: ['Get <span class="highlight">right</span> things done<span class="highlight">.</span>'],
                                loop: true,
                                contentType: 'html',
                                typeSpeed: 23,
                                backSpeed: 2,
                                backDelay: 988
                            }} />
                        </div>
                    </div>
                </div>
            );
        }

        const
            locale = session.Language,

            isPublicPage = session.PublicPagesEnabled && session.IsPublicPageUser,
            appRoutes = isPublicPage ? publicRoutes : routes,

            translationsForCurrentLanguage = messages.Data || {};

        return (
            <Provider store={store}>
                <IntlProvider locale={locale} messages={translationsForCurrentLanguage}>
                    <Router history={history} routes={appRoutes} />
                </IntlProvider>
            </Provider>
        );
    }
}

const AppContainer = connect(state => state.app)(App);

applyPolyfill().then(() => render(<AppContainer store={store} />, document.getElementById('app')));
